<template>
  <div>
    <div class="member-info-card">
    <card class="base-info-new">
      <AdminTitle title="用户资料" size="20px" />
      <div class="top-tags-box">
        <el-tag
          v-if="isJointOrder"
          effect="dark"
          class="order-mode-joint"
        >
          {{ detailInfo.orderModeName || "联营订单" }}
        </el-tag>
        <el-tag
          v-if="detailInfo.storeComboRouteName"
          effect="dark"
          class="store-combo-route"
        >
          {{ detailInfo.storeComboRouteName }}
        </el-tag>
        <el-tag v-if="member?.mobileStatus === 2" class="mobile-alert-tag">停机</el-tag>
        <el-tag v-if="member?.mobileStatus === 3" class="mobile-alert-tag">在网但不可用</el-tag>
        <el-tag v-if="member?.mobileStatus === 4" class="mobile-alert-tag">销号/空号</el-tag>
      </div>

      <div class="base-info-top">
        <div class="id-card-pic">
          <div class="id-pic-row">
            <el-image
              style="
                width: 100px;
                border-radius: 8px;
                height: 100px;
                margin-right: 10px;
              "
              :src="member.identityFrontImageUrl"
              :preview-src-list="[member.identityFrontImageUrl]"
            >
              <div
                style="
                  background: #f5f7fa;
                  width: 100px;
                  height: 100px;
                  line-height: 100px;
                  text-align: center;
                  color: #c0c4cc;
                "
                slot="error"
              >
                暂无图片
              </div>
            </el-image>
            <el-image
              style="width: 100px; border-radius: 8px; height: 100px"
              :src="member.identityBackImageUrl"
              :preview-src-list="[member.identityBackImageUrl]"
            >
              <div
                style="
                  background: #f5f7fa;
                  width: 100px;
                  height: 100px;
                  line-height: 100px;
                  text-align: center;
                  color: #c0c4cc;
                "
                slot="error"
              >
                暂无图片
              </div>
            </el-image>
          </div>
          <div v-if="detailInfo.previousBillOrder && detailInfo.previousBillOrder.orderNo" class="previous-order-actions">
          <el-button
            class="prev-bill-btn"
            type="primary"
            size="small"
            @click="goPreviousBill"
            ><img class="previous-action-icon" src="/static/review/previous-bill.png" alt="" />上笔账单</el-button
          >
          <el-button
            class="prev-bill-btn prev-order-btn"
            type="primary"
            size="small"
            @click="goPreviousOrder"
            ><img class="previous-action-icon" src="/static/review/previous-order.png" alt="" />上笔订单</el-button
          >
          </div>
        </div>
        <div class="person-info">
          <div>
            <span class="name fw700">{{ member.memberName }}</span>
            <el-tag type="success">年龄：{{ member.age }}</el-tag>
            <el-tag type="success">性别：{{ member.genderName || "" }}</el-tag>
            <span v-for="(item, i) in detailInfo.rosterLevelList" :key="i">
            <span class="tag-ku t3" v-if="item == 1" style="margin: 2px">白名单</span>
            <span class="tag-ku t1" v-if="item == 2" style="margin: 2px">
              <i class="el-icon-warning"></i>黑名单
            </span>
            <span class="tag-ku t2" v-if="item == 3" style="margin: 2px">
              <i class="el-icon-warning"></i>灰名单
            </span>
          </span>
            <span class="tag-ku t4" v-if="!!detailInfo.isInvisibleCredit" style="margin: 2px">白户</span>
          </div>
          <div>
          <span class="mr50">
            <span class="label">手机号：</span>
            <span class="fw700" style="margin-right: 5px;">{{ member.mobile }}</span>
            <el-button type="text" @click="copy">复制</el-button>
            <span style="margin-left: 5px;">
              <el-tag v-if="member?.mobileStatus === 0" type="info">无数据</el-tag>
              <el-tag v-else-if="member?.mobileStatus === 1" style="background-color: #4cd2a2; color: #fff">正常</el-tag>
              <el-tag v-else type="danger">异常</el-tag>
            </span>
          </span>
            <span>
            <span class="label">身份证号：</span>
            <span class="fw700">{{ member.identityNo }}</span>
          </span>
          </div>
          <div>
          <span>
            <span class="label">户籍所在地：</span>
            <span class="fw700">{{ member.identityAddress || "" }}</span>
          </span>
          </div>
          <div class="history-tag">
            <!--          <el-tag type="success">用户申请单量：{{ member ? member.applyOrderNum : '' }}</el-tag>-->
            <!--          <el-tag type="success">用户成单量：{{ member ? member.dealOrderNum : '' }}</el-tag>-->
            <!--          <el-tag type="success">用户结清单量：{{ member ? member.fullPayOrderNum : '' }}</el-tag>-->
            <el-tag type="success">上笔订单最长延期天数：{{ member ? member.previousOrderMaxExtendDayNum : "" }}</el-tag>
          </div>
          <!-- 展示最终首付比圆环及修改入口。 -->
          <div class="rating" v-if="!!detailInfo.store">
            <PrepayRateRing
                :rate="orderReviewV2.finalPrepayRate"
                :grade="orderReviewV2.finalPrepayGrade"
                :text-size="28"
                :stroke-width="16"
            >
              <el-button
                  v-if="prepayAdjustSysRate !== null && !rejectOnly"
                  class="edit-btn"
                  style="margin-left: 5px"
                  type="text"
                  size="small"
                  icon="el-icon-edit"
                  :disabled="!isShowBtn(AUTH_BTN.review_list_detail_update_final_grade)"
                  @click="openPrepayAdjust"
              >修改</el-button
              >
            </PrepayRateRing>
          </div>
        </div>
      </div>
      <div class="tips-row">
        <div class="tip tip-success" v-if="member.qualityCustomer === true">
          <span class="tip-text">优质客户 · 上笔实际首付高于可选最低档</span>
        </div>
        <div class="tip tip-warning" v-if="isAgeWarning">
          <i class="el-icon-bell"></i>
          <span class="tip-text">年轻客群（18-22）提示：建议收集收入证明！</span>
        </div>
        <div class="tip" v-if="fullPayTip">
          <i class="el-icon-warning"></i>
          <span class="tip-text">{{ fullPayTip }}</span>
        </div>
      </div>
      <div class="title">
        <span class="title-style fw700">客户补充资料</span>
        <span class="supple-inform-edit" @click="openSuppleInform">编辑</span>
      </div>
      <card class="base-info-new special-card">
        <el-row class="customer">
          <el-col
              :span="item.width ? item.width : 8"
              v-for="(item, index) in personInfoList"
              :key="index"
          >
            <span class="label">{{ item.label }}</span>
            <span class="value">{{
                item.dec
                    ? scoreProfileData[item.dec]
                    : scoreProfileData[item.prop] || "-"
              }}</span>
          </el-col>
        </el-row>
      </card>

      <el-dialog
          title="客户补充资料修改"
          :visible.sync="suppleInformDialog"
          width="800px"
          class="update-final-grade-dialog"
      >
        <el-row>
          <el-form
              :model="scoreProfileData"
              ref="scoreProfileData"
              label-width="130px"
              class="demo-ruleForm"
          >
            <el-col
                :span="item.prop == 'workCompany' ? 16 : 8"
                v-for="(item, index) in personInfoList"
                :key="index"
            >
              <el-form-item
                  :label="item.label"
                  :prop="item.prop"
                  :rules="
                item.require
                  ? [
                      {
                        required: true,
                        message: '该项不能为空',
                        trigger: 'blur',
                      },
                    ]
                  : []
              "
                  v-if="!item.type"
              >
                <el-input
                    v-model="scoreProfileData[item.prop]"
                    size="mini"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item
                  :label="item.label"
                  :prop="item.prop"
                  v-else
                  :rules="
                item.require
                  ? [
                      {
                        required: true,
                        message: '该项不能为空',
                        trigger: ['change', 'blur'],
                      },
                    ]
                  : []
              "
              >
                <SelectDict
                    width="100%"
                    size="mini"
                    v-model="scoreProfileData[item.prop]"
                    :dictCode="item.type"
                ></SelectDict>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <div slot="footer">
          <el-button @click="suppleInformDialog = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveProfile" size="small">保 存</el-button>
        </div>
      </el-dialog>

      <PrepayAdjustDialog
        :visible.sync="prepayAdjustDialog"
        :order-no="detailInfo.orderNo || ''"
        :machine-prepay-rate="prepayAdjustSysRate"
        @success="onPrepayAdjustSuccess"
      />
    </card>
    </div>

    <card v-if="detailInfo.orderRiskMember" class="base-info-new">
      <AdminTitle title="全域账号数据" size="20px" />

      <tp-table
        :showPagination="false"
        :tableData="detailInfo.orderRiskMember ? detailInfo.orderRiskMember.qyMemberList : []"
        :columns="qyMemberColumns"
      />
    </card>
  </div>
</template>

<script>
import { getOrderDetailRouteName } from "@/utils/order-detail-route";
import SelectDict from "@/views/components/select-dict.vue";
import PrepayAdjustDialog from "./prepay-adjust-dialog.vue";
import {
  hitOrderScoreProfileAPI,
  saveMemberProfileAPI,
} from "./api";
import { authBtnMixin } from "@/mixins/authBtnMixin";
const qyMemberColumns = [
  {
    label: '平台名称',
    prop: 'appName',
    minWidth: '150',
    customRender(h, row) {
      return <p>{row['appName']}</p>;
    },
  },
  {
    label: '手机号',
    prop: 'mobile',
    minWidth: '120',
    customRender(h, row) {
      return <p>{row['mobile']}</p>;
    },
  },
  {
    label: '申请单量',
    prop: 'applyOrderNum',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['applyOrderNum']}</p>;
    },
  },
  {
    label: '成单量',
    prop: 'dealOrderNum',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['dealOrderNum']}</p>;
    },
  },
  {
    label: '结清单量',
    prop: 'fullPayOrderNum',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['fullPayOrderNum']}</p>;
    },
  },
  {
    label: '在租单量',
    prop: 'inRentOrderNum',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['inRentOrderNum']}</p>;
    },
  },
  {
    label: '在逾单量',
    prop: 'inOverdueOrderNum',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['inOverdueOrderNum']}</p>;
    },
  },
];

export default {
  mixins: [authBtnMixin],
  components: { SelectDict, PrepayAdjustDialog },
  name: "BaseInfo",
  props: {
    rejectOnly: Boolean,
    detailInfo: {
      type: Object,
      default: () => {},
    },
    flag: {
      type: Boolean,
      default: true,
    },
    show_type: {
      type: String,
      default: "base",
    },
  },
  inject: ["reload"],
  data() {
    return {
      qyMemberColumns,
      scoreProfileData: {
        orderNo: "",
        memberId: "",
        sysHitScore: "",
        sysHitGrade: "",
        finalHitGrade: "",
        zmScore: "",
        creditStatus: "",
        rentHistory: "",
        involveStatus: "",
        inSchoolStatus: "",
        workCompany: "",
        jobCategory: "",
        jobName: "",
        income: "",
      },
      personInfoList: [
        {
          prop: "zmScore",
          label: "支付宝芝麻分：",
        },
        {
          prop: "creditStatus",
          label: "信用情况：",
          type: "member:creditStatus",
          dec: "creditStatusDesc",
        },
        {
          prop: "rentHistory",
          label: "租机历史：",
          type: "member:rentHistory",
          dec: "rentHistoryDesc",
        },
        {
          prop: "inSchoolStatus",
          label: "是否学生在读：",
          type: "member:inSchoolStatus",
          dec: "inSchoolStatusDesc",
        },
        {
          prop: "involveStatus",
          label: "涉诉情况：",
          type: "member:involveStatus",
          width: 16,
          dec: "involveStatusDesc",
        },
        {
          prop: "income",
          label: "月收入：",
        },
        {
          prop: "jobCategory",
          label: "工作类型：",
          type: "member:occupationalType",
          dec: "jobCategoryName",
        },

        {
          prop: "workCompany",
          label: "工作单位：",
        },
      ],
      suppleInformDialog: false,
      prepayAdjustDialog: false,

    };
  },
  computed: {
    /** 订单模式 3-联营订单 */
    isJointOrder() {
      return this.detailInfo.orderMode === 3;
    },
    member() {
      let mem = {};
      if (this.detailInfo.member) {
        mem = this.detailInfo.member;
      }
      return mem;
    },
    orderScoreProfile() {
      return this.detailInfo.orderScoreProfile || {};
    },
    orderReviewV2() {
      return this.detailInfo.orderReviewV2 || {};
    },
    isAgeWarning() {
      const age = Number(this.member.age);
      return age >= 18 && age <= 22;
    },
    fullPayTip() {
      let tip = '';
      if (this.detailInfo.orderRiskMember && !this.detailInfo.orderRiskMember.isFullPay) {
        tip = '客户有未结清订单，请复核后谨慎操作！';
      }
      return tip;
    },

    prepayAdjustSysRate() {
      const sysPrepayRate = this.orderReviewV2.machinePrepayRate;
      if (sysPrepayRate === null || sysPrepayRate === undefined || sysPrepayRate === "") {
        return null;
      }
      const num = Number(sysPrepayRate);
      return Number.isFinite(num) ? num : null;
    },

  },
  watch: {
    "$route.params.id"() {
      this.prepayAdjustDialog = false;
    },
    "detailInfo.orderNo"() {
      this.prepayAdjustDialog = false;
    },
    orderScoreProfile(val) {
      if (val && this.flag) {
        this.scoreProfileData = { ...this.orderScoreProfile, ...val };
      }
    },
  },

  deactivated() {
    this.prepayAdjustDialog = false;
  },
  methods: {
    openPrepayAdjust() {
      if (!this.isShowBtn(this.AUTH_BTN.review_list_detail_update_final_grade) || !this.detailInfo.orderNo) return;
      this.prepayAdjustDialog = true;
    },
    onPrepayAdjustSuccess() {
      this.$emit("update:flag", true);
      this.$emit("updateDetail");
    },

    goPreviousOrder() {
      const order = this.detailInfo.previousBillOrder;
      if (!order?.orderNo) return;
      const link = this.$router.resolve({
        name: getOrderDetailRouteName(order.createTime),
        params: { id: order.orderNo },
        query: {
          memberId: this.member.id,
          orderType: order.orderType,
        },
      });
      window.open(link.href, "_blank");
    },
    // 查看上笔账单详情
    goPreviousBill() {
      const order = this.detailInfo.previousBillOrder;
      if (!order?.orderNo) return;
      const link = this.$router.resolve({
        name: "OrderBill",
        params: { id: order.orderNo },
      });
      window.open(link.href, "_blank");
    },
    copy() {
      navigator.clipboard.writeText(
        `${this.member.memberName} ${this.member.mobile}`,
      );

      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    // 保存客户补充资料
    saveProfile() {
      this.$refs.scoreProfileData.validate((valid) => {
        if (valid) {
          if (this.detailInfo.store) {
            hitOrderScoreProfileAPI(this.scoreProfileData).then(() => {
              this.$message.success("保存成功");
              this.suppleInformDialog = false;
              this.$emit("update:flag", true);
              this.$emit("updateDetail");
            });
          } else {
            this.scoreProfileData.memberId = this.detailInfo.member.id;
            saveMemberProfileAPI(this.scoreProfileData).then(() => {
              this.$message.success("保存成功");
              this.suppleInformDialog = false;
              this.$emit("update:flag", true);
              this.$emit("updateDetail");
            });
          }
        }
      });
    },
    openSuppleInform() {
      this.suppleInformDialog = true;
    },

  },
};
</script>

<style lang="scss" scoped>
.member-info-card {
  position: relative;
}

.base-info-new {
  position: relative;

  /* 右上角标签容器 */
  .top-tags-box {
    position: absolute;
    top: -2px;
    right: 200px;
    display: flex;
    align-items: center;
    gap: 10px;
    z-index: 1;
  }

  /* 标签通用样式 */
  .order-mode-joint,
  .store-combo-route,
  .mobile-alert-tag {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    padding: 0 16px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 1px;
    border: none;
    border-radius: 17px;
    color: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    flex-shrink: 0;
  }

  .order-mode-joint {
    background-color: #f5932c;
  }

  .store-combo-route {
    background-color: #e85555;
  }

  .mobile-alert-tag {
    background-color: #e85555;
  }
}

.base-info-new /deep/ {
  border-color: transparent;
  margin-top: 20px;
  width: 100%;
  border-radius: 16px;
  color: #222222;
  .fw700 {
    font-weight: 700;
  }
  .label {
    color: #666666;
    font-size: 14px;
  }
  .ivu-card {
    border-radius: 18px;
  }
  .el-dialog__footer {
    padding-bottom: 30px !important;
  }
  .base-info-top {
    display: flex;
    align-items: flex-start;
    .id-card-pic {
      margin-right: 3%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .id-pic-row {
        display: flex;
      }
    }
    .person-info {
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: column;
      line-height: 35px;

      .mr50 {
        margin-right: 50px;
      }
      .el-tag {
        height: 25px;
        border-radius: 15px;
        margin-right: 10px;
        line-height: 25px;
      }
      .el-tag.el-tag--success {
        background-color: #fff;
        color: #666666;
        border-color: #e4e4e4;
      }
      .name {
        color: #222222;
        font-size: 18px;
        font-family: 微软雅黑;
        margin-right: 2%;
      }
      .rating {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
        .edit-btn {
          font-size: 14px;
        }
      }
    }
  }
  .tips-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;
    margin-top: 12px;
  }
  .tip {
    background-color: #f8eaeb;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;

    i {
      color: #e34d59;
      vertical-align: baseline;
    }

    .tip-text {
      color: #e34d59;
      font-weight: 700;
      margin-left: 5px;
    }
  }
  .tip-success {
    background-color: #e0ffed;
    text-align: center;

    .tip-text {
      color: #4cd2a2;
      margin-left: 0;
    }
  }
  .tip-warning {
    background-color: #fdf6ec;
    i {
      color: #e6a23c;
    }
    .tip-text {
      color: #e6a23c;
    }
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title-style {
      color: #333333;
      font-size: 16px;
    }
    .supple-inform-edit {
      cursor: pointer;
      background: #409eff;
      color: #fff;
      padding: 8px 18px;
      border-radius: 45px;
    }
  }

  .tag-ku {
    padding: 4px 12px;
    border-radius: 46px;
    font-size: 12px;
    margin-right: 5px;
    color: #fff;
    .el-icon-warning {
      color: #fff;
      font-size: 14px;
      margin-right: 5px;
    }
  }
  // 黑名单
  .t1 {
    background-color: #d05252;
  }
  // 灰名单
  .t2 {
    background-color: #fbb438;
  }
  // 白名单
  .t3 {
    background: #4cd2a2;
  }
  // 白户
  .t4 {
    background: #ff8a91;
  }
  .previous-order-actions {
    display: flex;
    justify-content: space-around;
    gap: 12px;
    width: 220px;
    margin-top: 10px;
  }
  .prev-bill-btn {
    padding: 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;

    color: #148AFF;
    background: #ECF5FF;
    border: none;
    margin: 0;

    &:hover:not(.is-disabled), &:focus:not(.is-disabled) {
      background: #ECF5FF;
    }

    .previous-action-icon {
      width: 14px;
      height: 14px;
      margin-right: 4px;
      object-fit: contain;
      vertical-align: -2px;
    }
  }
  .prev-order-btn {
    color: #1B71F2;
  }
  // 客户补充资料修改弹窗的头部、底部间距。
  .update-final-grade-dialog {
    .el-dialog__header {
      padding-top: 15px;
    }
    .el-dialog__footer {
      padding-top: 0;
    }
  }
}

.special-card {
  background: #f7f8fa;
  line-height: 35px;
  .label {
    min-width: 120px;
    display: inline-block;
    text-align: right;
  }
  .value {
    font-weight: 600;
  }
}
</style>
